export const errorsFromResponse = (response: any): Error[] => {
  const data = (response as any).data;

  if (!data) {
    return [];
  }

  return Object.keys(data).map((key) => new Error(`${key}: ${data[key]}`));
};

export const errorMessagesFromResponse = (response: any): string[] => {
  const data = (response as any).data;

  if (!data) {
    return [];
  }

  return Object.values(data);
};
